export function isMobile() {
  const userAgent = navigator.userAgent;

  // 检查是否为移动设备
  if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone|jbsn/.test(userAgent)) {
    return true;
  }

  // 如果没有匹配到任何关键词，则认为是PC端
  return false;
}

export function isPad() {
  const userAgent = navigator.userAgent;

  // 检查是否为移动设备
  if (/pad_true/.test(userAgent)) {
    return true;
  }

  // 如果没有匹配到任何关键词，则认为是PC端
  return false;
}

export function isAndroid() {
  const userAgent = navigator.userAgent;

  // 检查是否为移动设备
  if (/type_android/.test(userAgent)) {
    return true;
  }

  // 如果没有匹配到任何关键词，则认为是PC端
  return false;
}

export function isIOS() {
  const userAgent = navigator.userAgent;

  // 检查是否为移动设备
  if (/type_ios/.test(userAgent)) {
    return true;
  }

  // 如果没有匹配到任何关键词，则认为是PC端
  return false;
}

export function isWindows() {
  const userAgent = navigator.userAgent;

  // 检查是否为移动设备
  if (/type_windows/.test(userAgent)) {
    return true;
  }

  // 如果没有匹配到任何关键词，则认为是PC端
  return false;
}

export function isTcy() {
  const userAgent = navigator.userAgent;

  // console.log(`isTcy:${/com.jbsn.sduck/.test(userAgent)} isSno:${/com.jbsn.sno/.test(userAgent)}`)

  // 检查是否为移动设备
  if (/com.jbsn.sduck/.test(userAgent)) {
    return true;
  }

  // 如果没有匹配到任何关键词，则认为是PC端
  return false;
}

export function isSno() {
  const userAgent = navigator.userAgent;

  // 检查是否为移动设备
  if (/com.jbsn.sno/.test(userAgent)) {
    return true;
  }

  // 如果没有匹配到任何关键词，则认为是PC端
  return false;
}
